var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusMonitor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01013 2.25007C9.3292 2.25438 9.61061 2.46011 9.71151 2.76283L15.0308 18.7207L17.2952 12.4937C17.4029 12.1973 17.6846 12 18 12H22.4998C22.914 12 23.2498 12.3358 23.2498 12.75C23.2498 13.1642 22.914 13.5 22.4998 13.5H18.5253L15.7048 21.2563C15.5958 21.5562 15.3089 21.7542 14.9899 21.7499C14.6708 21.7456 14.3894 21.5399 14.2885 21.2372L8.9692 5.27932L6.70485 11.5063C6.59707 11.8027 6.31538 12 6 12H1.49976C1.08554 12 0.749756 11.6642 0.749756 11.25C0.749756 10.8358 1.08554 10.5 1.49976 10.5H5.47468L8.29516 2.74369C8.4042 2.44381 8.69106 2.24576 9.01013 2.25007Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusMonitor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/status-monitor.6cca20618a8b309858d4ef4b44ccdaf8.svg";